import { ensureLanguageStored, FALLBACK_LANGUAGE } from "./languagePreferences";

export function getInitialLanguage() {
  if (typeof window === "undefined") {
    return FALLBACK_LANGUAGE;
  }

  return ensureLanguageStored();
}
